import { IconButton } from '@fluentui/react';
import styled from 'styled-components';

export const MonthSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  height: 0.75rem;
  margin-bottom: 2rem;
`;

export const MonthSelectorTitle = styled.h1`
  font-weight: 500;
  font-size: 1rem;
`;

export const MonthSelectorButtons = styled(IconButton)`
  color: ${(props) => props.theme.calendarDateColor};
  &:hover {
    color: ${(props) => props.theme.calendarDateColorHover};
  }
  &:active {
    color: ${(props) => props.theme.calendarDateColorHover};
  }
`;
